<template>
<div>
    <design-renewal-form :getDesignRenewalList="getDesignRenewalList" ref="designRenewalFormModal"></design-renewal-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('designRenewal.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="designRenewalTable" ref="designRenewalTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'no'" class="text-nowrap">
                {{ $t('designRenewal.no') }}
            </span>
            <span v-else-if="props.column.field === 'date'" class="text-nowrap">
                {{ $t('designRenewal.date') }}
            </span>
            <span v-else-if="props.column.field === 'reminderDate'" class="text-nowrap">
                {{ $t('designRenewal.reminder_date') }}
            </span>
            <span v-else-if="props.column.field === 'paymentDate'" class="text-nowrap">
                {{ $t('designRenewal.payment_date') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        designId: Number,
        designFormSaved: Boolean
    },
    watch: {
      designFormSaved(val){
        if(val == true){
            this.getDesignRenewalList()
        }
      }
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('designRenewal.no'),
                    field: `no`,
                },
                {
                    label: this.$t('designRenewal.date'),
                    field: `date`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('designRenewal.reminder_date'),
                    field: `reminderDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('designRenewal.payment_date'),
                    field: `paymentDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getDesignRenewalList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'DesignRenewal'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getDesignRenewalList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getDesignRenewalList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.designRenewalFormModal.showInfo(id, this.designId)
        },
        getDesignRenewalList() {
            this.rows = []
            const data = {
                id: this.designId
            }
            const controller = {
                name: 'DesignRenewal',
                actionName: 'GetDesignRenewalListByDesignId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.designRenewalList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
